/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedPortfolioWorkListPublic } from './PaginatedPortfolioWorkListPublic'
import {
  PaginatedPortfolioWorkListPublicFromJSON,
  PaginatedPortfolioWorkListPublicFromJSONTyped,
  PaginatedPortfolioWorkListPublicToJSON,
} from './PaginatedPortfolioWorkListPublic'

/**
 *
 * @export
 * @interface EnvelopedPortfolioWorkListPortfolioWorkListPublic
 */
export interface EnvelopedPortfolioWorkListPortfolioWorkListPublic {
  /**
   *
   * @type {PaginatedPortfolioWorkListPublic}
   * @memberof EnvelopedPortfolioWorkListPortfolioWorkListPublic
   */
  body: PaginatedPortfolioWorkListPublic
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedPortfolioWorkListPortfolioWorkListPublic
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedPortfolioWorkListPortfolioWorkListPublic interface.
 */
export function instanceOfEnvelopedPortfolioWorkListPortfolioWorkListPublic(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedPortfolioWorkListPortfolioWorkListPublicFromJSON(
  json: any,
): EnvelopedPortfolioWorkListPortfolioWorkListPublic {
  return EnvelopedPortfolioWorkListPortfolioWorkListPublicFromJSONTyped(json, false)
}

export function EnvelopedPortfolioWorkListPortfolioWorkListPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedPortfolioWorkListPortfolioWorkListPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedPortfolioWorkListPublicFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedPortfolioWorkListPortfolioWorkListPublicToJSON(
  value?: EnvelopedPortfolioWorkListPortfolioWorkListPublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedPortfolioWorkListPublicToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
